import { erpAxios } from '..';

const notifUnreadCount = async (officerId) => {
  const { data } = await erpAxios(`/sistemskeNotifikacije/countUnread/${officerId}`);
  return data;
};

export default notifUnreadCount;